import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark py-12 border-t border-white/10" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-88">
        <div className="text-center mb-8" data-id="element-89">
          <h3 className="text-2xl font-heading font-bold text-white tracking-wider mb-2" data-id="element-90">
            Mensajes Magnéticos
          </h3>
          <p className="text-rose-200 text-sm italic" data-id="element-91">
            El sistema que hace que Él te busque, te desee y te priorice
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-8" data-id="element-92">
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-93">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-94">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-95">
            Contacto
          </a>
        </div>

        <div className="text-center text-gray-500 text-sm" data-id="element-96">
          <p data-id="element-97">© 2026 Mensajes Seductores. Todos los derechos reservados.</p>
          <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-98">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}